import { render, staticRenderFns } from "./CouponSettingSelector.vue?vue&type=template&id=5992fc75&scoped=true&"
import script from "./CouponSettingSelector.vue?vue&type=script&lang=js&"
export * from "./CouponSettingSelector.vue?vue&type=script&lang=js&"
import style0 from "./CouponSettingSelector.vue?vue&type=style&index=0&id=5992fc75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992fc75",
  null
  
)

export default component.exports